import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import {
  getClientUserCommunications,
  Communication,
} from "./communicationsApi";

export function useGetClientUserCommunications(
  clientUuid: string,
  userUuid: string,
  options?: UseQueryOptions<
    Communication[],
    Error,
    Communication[],
    [string, string, string]
  >,
) {
  return useQuery({
    ...options,
    queryKey: ["client-user-communications", clientUuid, userUuid],
    queryFn: () => getClientUserCommunications(clientUuid, userUuid),
  });
}
